import { render } from "./BlogHomeDeliveryDate.vue?vue&type=template&id=56128af9"
import script from "./BlogHomeDeliveryDate.vue?vue&type=script&lang=js"
export * from "./BlogHomeDeliveryDate.vue?vue&type=script&lang=js"

import "./BlogHomeDeliveryDate.vue?vue&type=style&index=0&id=56128af9&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__